import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
store.dispatch('getcitylist')
import mixins from './mixins'
Vue.mixin(mixins)
import { EventBus } from './utils/eventBus';
// 将 EventBus 挂载到 Vue 原型上
Vue.prototype.$eventBus = EventBus;
import env from "./utils/env";
Vue.prototype.$env = env;
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// 引入全局组件
// 头部导航
import Header from './components/header.vue'
Vue.component('Header', Header)
// 底部导航
import Footer from './components/footer.vue'
Vue.component('Footer', Footer)
// 右侧固定
import Fixedright from './components/fixedright.vue'
Vue.component('Fixedright', Fixedright)
// 空白状态
import Empty from './components/empty.vue'
Vue.component('Empty', Empty)
// 分页器
import Pagination from './components/pagination.vue'
Vue.component('Pagination', Pagination)
// 视频播放器弹出框
import Videodialog from './components/videodialog.vue'
Vue.component('Videodialog', Videodialog)
// 日期选择器
import DatePicker from './components/datePicker.vue'
Vue.component('DatePicker', DatePicker)
// 下拉选择器
import Select from './components/Select.vue'
Vue.component('Select', Select)
// 城市选择器
import Citypicker from './components/citypicker.vue'
Vue.component('Citypicker', Citypicker)
// 富文本弹出框
import Htmldialog from './components/htmldialog.vue'
Vue.component('Htmldialog', Htmldialog)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
